import React, { useState, useCallback } from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import FlowCanvas from './components/FlowCanvas';
import Sidebar from './components/Sidebar';
import PropertyPanel from './components/PropertyPanel';
import Topbar from './components/Topbar';
import AutomationService from '../../services/automationService';
import './AdminAutomation.css';

const AdminAutomation = () => {
    const [selectedNode, setSelectedNode] = useState(null);
    const [currentWorkflow, setCurrentWorkflow] = useState(null);

    const onNodeSelect = useCallback((node) => {
        setSelectedNode(node);
    }, []);

    const onSave = async (name, flow, triggerType = 'manual') => {
        try {
            let workflowId = currentWorkflow?.id;

            // 1. Create or Update Workflow
            if (!workflowId) {
                const newWorkflow = await AutomationService.createWorkflow({
                    name: name,
                    trigger_type: triggerType,
                    is_active: true // Auto-activate for now
                });
                workflowId = newWorkflow.id;
                setCurrentWorkflow(newWorkflow);
            } else {
                // Update name or trigger_type
                await AutomationService.updateWorkflow(workflowId, {
                    name,
                    trigger_type: triggerType,
                    is_active: true
                });
                setCurrentWorkflow(prev => ({ ...prev, name, trigger_type: triggerType }));
            }

            // 2. Save Version
            const version = await AutomationService.saveVersion(workflowId, flow);

            // 3. Publish (Optional: auto-publish for now to make testing easier)
            await AutomationService.publishVersion(workflowId, version.id);

            alert('Workflow saved and published successfully!');

        } catch (error) {
            console.error("Save failed", error);
            alert('Failed to save workflow. See console for details.');
        }
    };

    return (
        <div className="admin-automation-container">
            <ReactFlowProvider>
                <Topbar workflow={currentWorkflow} onSave={onSave} />
                <div className="automation-layout">
                    <Sidebar />
                    <div className="canvas-wrapper">
                        <FlowCanvas onNodeSelect={onNodeSelect} />
                    </div>
                    <PropertyPanel selectedNode={selectedNode} />
                </div>
            </ReactFlowProvider>
        </div>
    );
};

export default AdminAutomation;
